import { createContext } from 'react';

// Este archivo solo exporta el contexto.
// No contiene ningún componente React, solucionando así el problema de Fast Refresh.
export const AuthContext = createContext(null);
